import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, ProjectTypeCountDto } from '../../../../../shared/service-proxies/service-proxies';
import { AppNavigationService } from '../../../../shared/layout/nav/app-navigation.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
interface TimeOffInfo {
    name: string;
    value: string;
}
@Component({
    standalone: false,
    selector: 'app-leave-report-info',
    templateUrl: './leave-report-info.component.html',
    styleUrls: ['./leave-report-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeaveReportInfoComponent extends AppComponentBase implements OnInit {
    view: any[] = [200, 300];
    name = 'Angular';
    timeDetails: ProjectTypeCountDto[] = [];
    tempArray: any[] = [];
    timeDetailsName: string;
    isLoading: boolean = false;
    isEmpty: boolean = true;
    noData: boolean = false;
    isLeavesMenuVisible: boolean = false;
    TimeOffInfoDetails: TimeOffInfo = { name: "", value: "" };
    colorScheme = {
        domain: ['#EFA130', '#DB5AD7', '#57B02B', '#E93C29', '#567480', '#4AB7F7'] // Adjusted color codes
    };
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy, private _appNavigationService: AppNavigationService, injector: Injector, private router: Router) {
        super(injector);
    }
    ngOnInit(): void {
        this.checkLeavesMenuVisibility();
        this.timeOffDetails();
    }
    checkLeavesMenuVisibility(): void {
        const menu = this._appNavigationService.getMenu();
        const leavesMenuItem = menu.items.find(item => item.name === 'Leaves');
        if (leavesMenuItem) {
            this.isLeavesMenuVisible = this._appNavigationService.showMenuItem(leavesMenuItem);
        }
        else {
            this.isLeavesMenuVisible = false;
        }
    }
    getColorForDetails(detailName: string): string {
        const colorMap = {
            'Parent leave': '#EFA130',
            'Vacation': '#4AB7F7',
            'Unpaid leave': '#567480',
            'Sick': '#E93C29',
            'Casual Leave': '#57B02B',
            'Public holiday': '#DB5AD7',
        };
        return colorMap[detailName] || ''; // Return the mapped color, or empty string if not found
    }
    async timeOffDetails() {
        await this._AllDashboardServiceProxy.getTimeOffInfo('', [], [], [], '', undefined, undefined).subscribe(result => {
            result.forEach(x => {
                if (x.name == 'ParentalLeave') {
                    x.name = 'Parent leave';
                }
                else if (x.name == 'UnpaidLeave') {
                    x.name = 'Unpaid leave';
                }
                else if (x.name == 'PublicHoliday') {
                    x.name = 'Public holiday';
                }
                else if (x.name == 'CasualLeave') {
                    x.name = 'Casual Leave';
                }
                this.timeDetails.push(x);
            });
            this.isLoading = true;
            result.forEach(x => {
                if (x.value) {
                    this.isEmpty = false;
                    this.noData = true;
                }
            });
            this.markForCheck();
        });
    }
    viewall() {
        this.router.navigate([AppRoutes.leaves]);
    }
}
